import { StandardEvents } from '@shopify/events';
class GoodLotCollection {
  constructor(root) {
  this.root = root;
  this.sectionId = root.dataset.sectionId;

  this.handleRootClick = this.handleRootClick.bind(this);
  this.handleKeydown = this.handleKeydown.bind(this);
  this.handlePopState = this.handlePopState.bind(this);
  this.handleCollectionCartUpdate =
    this.handleCollectionCartUpdate.bind(this);

    this.bindStaticEvents();
    this.refreshDynamicRefs();
    this.bindDynamicEvents();
    this.setupPriceRanges();
    this.animateCards();
  }

  bindStaticEvents() {
  this.root.addEventListener('click', this.handleRootClick);
  this.root.addEventListener('keydown', this.handleKeydown);
  this.root.addEventListener(
    StandardEvents.cartLinesUpdate,
    this.handleCollectionCartUpdate
  );

  window.addEventListener('popstate', this.handlePopState);
}

  refreshDynamicRefs() {
    this.dynamic = this.root.querySelector('[data-goodlot-collection-dynamic]');
    this.results = this.root.querySelector('[data-goodlot-results]');
    this.form = this.root.querySelector('[data-goodlot-filter-form]');
    this.drawer = this.root.querySelector('[data-goodlot-filter-drawer]');
  }

  bindDynamicEvents() {
    this.root.querySelectorAll('[data-goodlot-filter-open]').forEach((button) => {
      button.addEventListener('click', () => this.openDrawer());
    });

    this.root.querySelectorAll('[data-goodlot-filter-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeDrawer());
    });

    this.root.querySelectorAll('[data-goodlot-filter-input]').forEach((input) => {
      input.addEventListener('change', () => {
        this.enforceDiscountSingleSelection(input);
        this.applyFilters({ keepDrawer: this.isDrawerOpen() });
      });
    });

    this.root.querySelectorAll('[data-goodlot-price-range]').forEach((input) => {
      input.addEventListener('input', () => this.updatePriceRange(input));

      input.addEventListener('change', () => {
        this.applyFilters({ keepDrawer: this.isDrawerOpen() });
      });
    });

    const sortSelect = this.root.querySelector('[data-goodlot-sort]');

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const hiddenSort = this.root.querySelector('[data-goodlot-sort-hidden]');

        if (hiddenSort) hiddenSort.value = sortSelect.value;

        this.applyFilters({ keepDrawer: false });
      });
    }

    this.root
      .querySelectorAll(
        '.goodlot-active-filter, .goodlot-clear-all, .goodlot-filter-rail__clear, .goodlot-filter-drawer__clear'
      )
      .forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!link.href) return;

          event.preventDefault();

          this.fetchSection(new URL(link.href), {
            keepDrawer: this.isDrawerOpen(),
            historyMode: 'replace',
          });
        });
      });

    const loadMoreButton = this.root.querySelector('[data-goodlot-load-more]');

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        this.loadMore(loadMoreButton);
      });
    }
  }

  handleRootClick(event) {
    const groupToggle = event.target.closest('[data-goodlot-group-toggle]');

    if (groupToggle && this.root.contains(groupToggle)) {
      const group = groupToggle.closest('[data-goodlot-collapsible-group]');

      if (!group) return;

      const isExpanded = group.classList.toggle('is-expanded');

      groupToggle.setAttribute(
        'aria-expanded',
        isExpanded ? 'true' : 'false'
      );

      return;
    }

    const pill = event.target.closest(
      '.goodlot-collection-switcher__pill, .goodlot-collection-switcher__category-card'
    );

    if (!pill || !this.root.contains(pill) || !pill.href) return;

    // Allow normal browser behavior for modified clicks / new-tab gestures.
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const targetUrl = new URL(pill.href, window.location.origin);

    if (targetUrl.origin !== window.location.origin) return;

    event.preventDefault();

    const currentUrl = new URL(window.location.href);

    if (
      pill.classList.contains('is-active') &&
      targetUrl.pathname === currentUrl.pathname &&
      targetUrl.search === currentUrl.search
    ) {
      return;
    }

    this.fetchSection(targetUrl, {
      keepDrawer: false,
      historyMode: 'push',
      isCollectionSwitch: true,
    });
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isDrawerOpen()) {
      this.closeDrawer();
    }
  }
handleCollectionCartUpdate(event) {
  if (event.action !== 'add') return;

  const openCartDrawer = () => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');

    if (drawer?.open && !drawer.isOpen) {
      drawer.open();
    }
  };

  /*
   * Wait until Shopify has actually finished adding the item.
   *
   * Because this listener is attached ONLY to the GoodLot collection root,
   * it cannot affect Homepage or Product Page cart behavior.
   *
   * Opening the existing theme-drawer also triggers the existing
   * DrawerOpenEvent, so the GoodLot mobile 320ms slide-up animation
   * continues to be owned by cart-drawer.js.
   */
  if (event.promise) {
    event.promise
      .then(({ detail }) => {
        if (detail?.didError) return;

        openCartDrawer();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[GoodLot Collection] Cart drawer auto-open failed:',
            error
          );
        }
      });

    return;
  }

  openCartDrawer();
}
  handlePopState() {
    if (!document.documentElement.contains(this.root)) return;

    this.fetchSection(new URL(window.location.href), {
      keepDrawer: false,
      historyMode: 'none',
      isCollectionSwitch: true,
    });
  }

  enforceDiscountSingleSelection(input) {
    if (!input.matches('[data-goodlot-discount-tier]')) return;
    if (!input.checked) return;

    const discountGroup = input.closest('.goodlot-filter-group--discount');

    if (!discountGroup) return;

    discountGroup
      .querySelectorAll('[data-goodlot-discount-tier]')
      .forEach((otherInput) => {
        if (otherInput !== input) otherInput.checked = false;
      });
  }

  isDrawerOpen() {
    return Boolean(this.drawer?.classList.contains('is-open'));
  }

  openDrawer() {
    if (!this.drawer) return;

    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('goodlot-filter-open');

    this.root.querySelectorAll('[data-goodlot-filter-open]').forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });
  }

  closeDrawer() {
    if (!this.drawer) return;

    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('goodlot-filter-open');

    this.root.querySelectorAll('[data-goodlot-filter-open]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  setupPriceRanges() {
    this.root.querySelectorAll('[data-goodlot-price-range]').forEach((input) => {
      this.updatePriceRange(input);
    });
  }

  updatePriceRange(input) {
    const min = Number(input.min || 0);
    const max = Number(input.max || 1);
    const value = Number(input.value || max);

    const fill = ((value - min) / Math.max(1, max - min)) * 100;

    input.style.setProperty(
      '--goodlot-price-fill',
      `${Math.max(0, Math.min(100, fill))}%`
    );

    const group = input.closest('.goodlot-filter-group');
    const label = group?.querySelector('[data-goodlot-price-label]');

    if (label) label.textContent = this.money(value);
  }

  money(value) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }).format(value);
    } catch {
      return `$${Math.round(Number(value))}`;
    }
  }

  applyFilters({ keepDrawer = false } = {}) {
    if (!this.form) return;

    const params = new URLSearchParams();
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const hiddenSort = this.root.querySelector('[data-goodlot-sort-hidden]');

    if (hiddenSort?.value) {
      params.set(hiddenSort.name, hiddenSort.value);
    }

    const filterScope = isMobile
      ? this.root.querySelector('.goodlot-filter-drawer__body')
      : this.root.querySelector('.goodlot-filter-rail');

    if (filterScope) {
      filterScope.querySelectorAll('input[name]').forEach((input) => {
        if (input.disabled) return;

        if (
          (input.type === 'checkbox' || input.type === 'radio') &&
          !input.checked
        ) {
          return;
        }

        if (input.value === '' || input.value == null) return;

        if (input.matches('[data-goodlot-price-range]')) {
          const value = Number(input.value);
          const max = Number(input.max);

          if (Number.isFinite(value) && Number.isFinite(max) && value >= max) {
            return;
          }
        }

        params.append(input.name, input.value);
      });
    }

    params.delete('page');

    // The live URL already points at the currently selected collection.
    const url = new URL(window.location.href);
    url.search = params.toString();

    this.fetchSection(url, {
      keepDrawer,
      historyMode: 'replace',
    });
  }

  async fetchSection(
    url,
    {
      keepDrawer = false,
      historyMode = 'replace',
      isCollectionSwitch = false,
    } = {}
  ) {
    if (!this.dynamic || !this.results) return;

    const drawerBody = this.root.querySelector('.goodlot-filter-drawer__body');
    const drawerScrollTop = keepDrawer ? drawerBody?.scrollTop || 0 : 0;

    const preservedPageScrollY =
      isCollectionSwitch ? window.scrollY : null;

    this.results.setAttribute('aria-busy', 'true');
    this.root.classList.add('is-loading');

    const requestUrl = new URL(url.toString());
    requestUrl.searchParams.set('section_id', this.sectionId);

    try {
      const response = await fetch(requestUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const template = document.createElement('template');
      template.innerHTML = html.trim();

      const nextRoot = template.content.querySelector('[data-goodlot-collection]');
      const nextDynamic = nextRoot?.querySelector('[data-goodlot-collection-dynamic]');

      if (!nextRoot || !nextDynamic) {
        throw new Error('GoodLot collection dynamic content was not found.');
      }

      /*
       * MOBILE FILTER DRAWER — KEEP IT VISUALLY OPEN DURING AJAX UPDATE
       *
       * Previously the incoming section HTML contained a closed drawer.
       * Replacing the dynamic DOM briefly inserted that closed state, then
       * openDrawer() ran a moment later. On iPhone this looked like the sheet
       * closed and immediately reopened every time a filter was selected.
       *
       * Mark the incoming drawer as open BEFORE it enters the live DOM so
       * there is never a closed frame between the old and new filter states.
       */
      if (keepDrawer) {
        const nextDrawer = nextDynamic.querySelector('[data-goodlot-filter-drawer]');

        if (nextDrawer) {
          nextDrawer.classList.add('is-open');
          nextDrawer.setAttribute('aria-hidden', 'false');
        }

        nextDynamic.querySelectorAll('[data-goodlot-filter-open]').forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });
      }

      /*
       * TRUE PERSISTENT CATEGORY SELECTOR
       * =================================
       * Never detach/reinsert the collection switcher.
       *
       * In the mobile recording, the previous implementation briefly reset
       * the category track to scrollLeft = 0 when the selector DOM was moved
       * into the incoming AJAX fragment. A moment later it animated back,
       * which created the visible flash / left-right shake.
       *
       * This version keeps the live selector in place permanently:
       * - collection switch: sync active nav state, replace intro + results
       * - filter/sort: replace results only
       */

      const nextResults = nextDynamic.querySelector('[data-goodlot-results]');

      if (!nextResults) {
        throw new Error('GoodLot collection results were not found.');
      }

      /*
       * If the mobile drawer should remain open, prepare the incoming
       * RESULTS node before it enters the live DOM.
       */
      if (keepDrawer) {
        const nextDrawer = nextResults.querySelector(
          '[data-goodlot-filter-drawer]'
        );

        if (nextDrawer) {
          nextDrawer.classList.add('is-open');
          nextDrawer.setAttribute('aria-hidden', 'false');
        }

        nextResults
          .querySelectorAll('[data-goodlot-filter-open]')
          .forEach((button) => {
            button.setAttribute('aria-expanded', 'true');
          });
      }

      if (isCollectionSwitch) {
        const currentSwitcher = this.root.querySelector(
          '[data-goodlot-collection-switcher]'
        );

        const nextSwitcher = nextDynamic.querySelector(
          '[data-goodlot-collection-switcher]'
        );

        /*
         * Sync only active classes / aria-current.
         * The current carousel node, scrollLeft and listeners stay untouched.
         */
        if (currentSwitcher && nextSwitcher) {
          const getPath = (anchor) => {
            try {
              return new URL(
                anchor.href,
                window.location.origin
              ).pathname;
            } catch {
              return anchor.getAttribute('href') || '';
            }
          };

          const nextAnchors = [
            ...nextSwitcher.querySelectorAll(
              '.goodlot-collection-switcher__pill, [data-goodlot-category-card]'
            ),
          ];

          const stateByPath = new Map(
            nextAnchors.map((anchor) => [
              getPath(anchor),
              {
                active: anchor.classList.contains('is-active'),
                ariaCurrent: anchor.getAttribute('aria-current'),
              },
            ])
          );

          currentSwitcher
            .querySelectorAll(
              '.goodlot-collection-switcher__pill, [data-goodlot-category-card]'
            )
            .forEach((anchor) => {
              const state = stateByPath.get(getPath(anchor));

              if (!state) return;

              anchor.classList.toggle('is-active', state.active);

              if (state.ariaCurrent) {
                anchor.setAttribute(
                  'aria-current',
                  state.ariaCurrent
                );
              } else {
                anchor.removeAttribute('aria-current');
              }
            });
        }

        /* Replace only the collection intro under the persistent selector. */
        const currentIntro = this.dynamic.querySelector(
          '.goodlot-collection__page-intro'
        );

        const nextIntro = nextDynamic.querySelector(
          '.goodlot-collection__page-intro'
        );

        if (currentIntro && nextIntro) {
          currentIntro.replaceWith(
            document.importNode(nextIntro, true)
          );
        } else if (currentIntro && !nextIntro) {
          currentIntro.remove();
        } else if (!currentIntro && nextIntro) {
          const liveSwitcher = this.dynamic.querySelector(
            '[data-goodlot-collection-switcher]'
          );

          liveSwitcher?.insertAdjacentElement(
            'afterend',
            document.importNode(nextIntro, true)
          );
        }
      }

      /* Results are the only large content block that is replaced. */
      const importedResults = document.importNode(nextResults, true);

      this.results.replaceWith(importedResults);

      /*
       * Keep the viewport exactly where it was during a collection switch.
       * Since the selector itself never moved, this is only a safety lock
       * against browser scroll anchoring caused by intro/result height changes.
       */
      if (
        isCollectionSwitch &&
        preservedPageScrollY !== null &&
        Math.abs(window.scrollY - preservedPageScrollY) > 1
      ) {
        window.scrollTo(
          window.scrollX,
          preservedPageScrollY
        );
      }

      // Keep the hero completely untouched. Only update the breadcrumb text
      // so the page still reflects the active collection.
      const nextBreadcrumbs = nextRoot.querySelectorAll(
        '.goodlot-collection__breadcrumb-current'
      );
      const currentBreadcrumbs = this.root.querySelectorAll(
        '.goodlot-collection__breadcrumb-current'
      );

      currentBreadcrumbs.forEach((node, index) => {
        const nextNode = nextBreadcrumbs[index];
        if (nextNode) node.textContent = nextNode.textContent;
      });

      const cleanUrl = new URL(url.toString());
      cleanUrl.searchParams.delete('section_id');

      if (historyMode === 'push') {
        history.pushState({ goodlotCollection: true }, '', cleanUrl.toString());
      } else if (historyMode === 'replace') {
        history.replaceState({ goodlotCollection: true }, '', cleanUrl.toString());
      }

      this.refreshDynamicRefs();
      this.bindDynamicEvents();
      this.setupPriceRanges();
      this.animateCards();

      document.dispatchEvent(
        new CustomEvent('goodlot:collection-dynamic-updated', {
          detail: {
            collectionUrl: cleanUrl.toString(),
            isCollectionSwitch,
          },
        })
      );

      if (keepDrawer) {
        this.openDrawer();

        requestAnimationFrame(() => {
          const nextDrawerBody = this.root.querySelector(
            '.goodlot-filter-drawer__body'
          );

          if (nextDrawerBody) {
            nextDrawerBody.scrollTop = drawerScrollTop;
          }
        });
      }
    } catch (error) {
      console.error('[GoodLot Collection]', error);

      this.results?.setAttribute('aria-busy', 'false');
      this.root.classList.remove('is-loading');

      // If a collection uses a different template and Shopify cannot return
      // this section, fall back to normal navigation rather than a dead link.
      if (isCollectionSwitch) {
        window.location.assign(url.toString());
      }
    }
  }

  async loadMore(button) {
    const nextUrl = button.dataset.nextUrl;

    if (!nextUrl) return;

    button.disabled = true;
    button.textContent = 'Loading…';

    const requestUrl = new URL(nextUrl, window.location.origin);
    requestUrl.searchParams.set('section_id', this.sectionId);

    try {
      const response = await fetch(requestUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const template = document.createElement('template');
      template.innerHTML = html.trim();

      const nextRoot = template.content.querySelector('[data-goodlot-collection]');
      const nextItems = nextRoot?.querySelectorAll('[data-goodlot-product-item]');
      const grid = this.root.querySelector('[data-goodlot-product-grid]');

      if (!nextItems || !grid) {
        throw new Error('Load-more product grid was not found.');
      }

      nextItems.forEach((item) => {
        item.classList.add('goodlot-is-entering');
        grid.append(item);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.classList.remove('goodlot-is-entering');
          });
        });
      });

      const nextButton = nextRoot.querySelector('[data-goodlot-load-more]');

      if (nextButton?.dataset.nextUrl) {
        button.dataset.nextUrl = nextButton.dataset.nextUrl;
        button.disabled = false;
        button.textContent = 'Load more';
      } else {
        button.closest('.goodlot-collection__load-more-wrap')?.remove();
      }
    } catch (error) {
      console.error('[GoodLot Collection: load more]', error);

      button.disabled = false;
      button.textContent = 'Load more';
    }
  }

  animateCards() {
    const items = this.root.querySelectorAll('[data-goodlot-product-item]');

    items.forEach((item, index) => {
      item.classList.add('goodlot-is-entering');

      window.setTimeout(() => {
        item.classList.remove('goodlot-is-entering');
      }, Math.min(index * 30, 240));
    });

    this.root.classList.remove('is-loading');
    this.results?.setAttribute('aria-busy', 'false');
  }
}

function initGoodLotCollection(root) {
  if (!root || root.dataset.goodlotInitialized === 'true') return null;

  root.dataset.goodlotInitialized = 'true';

  return new GoodLotCollection(root);
}

function initAllGoodLotCollections(scope = document) {
  scope.querySelectorAll('[data-goodlot-collection]').forEach((root) => {
    initGoodLotCollection(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initAllGoodLotCollections(document),
    { once: true }
  );
} else {
  initAllGoodLotCollections(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGoodLotCollections(event.target);
});